import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { MonitorOrderAdminDto } from '@/backend/market'
import { OrderLiveEntity } from '@/features/trackOrderTwo/domain/entities/orderEntities/OrderLiveEntity'
import { OrderLiveAddressModel } from './OrderLiveAddressModel'
import { OrderLiveBranchModel } from './OrderLiveBranchModel'

export class OrderLiveModel extends OrderLiveEntity {
  constructor(dataDto: MonitorOrderAdminDto) {
    const orderLiveAddressModel = new OrderLiveAddressModel(dataDto.address)
    const orderLiveBranchModel = new OrderLiveBranchModel(dataDto.branch)
    super()

    mapEntityProperties<OrderLiveEntity>(this, dataDto, {
      map: {
        address: orderLiveAddressModel,
        branch: orderLiveBranchModel,
        region: dataDto?.service?.region
      }
    })
  }
}
